// 빈/로딩/에러 상태 (시안 .empty). props: loaded, error, text, action:{label, onClick}
// loaded=false → '불러오는 중…' / error → 에러 문장(danger) / 그 외 → text + 다음 행동 버튼
import React from 'react';
import { S, T } from '../theme';

function EmptyState(props) {
  if (!props.loaded) return <div className="v2-empty" style={S.emptyText}>불러오는 중…</div>;
  if (props.error) return <div className="v2-empty" style={Object.assign({}, S.emptyText, { color: T.danger })}>{typeof props.error === 'string' ? props.error : '불러오지 못했습니다.'}</div>;
  return (<div className="v2-empty" style={S.emptyText}>
    <div>{props.text || '표시할 항목이 없습니다.'}</div>
    {props.action ? <button type="button" style={Object.assign({}, S.btn, { marginTop: 10 })} onClick={props.action.onClick}>{props.action.label}</button> : null}
  </div>);
}

export default EmptyState;
